import {configureStore, ThunkAction, Action, combineSlices} from '@reduxjs/toolkit';
import {authSlice, setState} from './features/auth';
import {themeSlice} from "./features/theme/themeSlice";
import language_slice from "@/app/utils/language_slice";
import {homeSlice} from "@/app/features/home";

const rootReducer = combineSlices(themeSlice, themeSlice, language_slice, authSlice, homeSlice);

export const store = configureStore({
    reducer: rootReducer
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
